import React from "react";
// import "/node_modules/flag-icons/css/flag-icons.min.css";

export default function FlagImg({ flagCode }) {
  return flagCode && <span className={`flag-img fi fi-${flagCode.toLocaleLowerCase()}`} />;
}
